import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  username: "",
  token: "",
  refreshToken: "",
};

const authReducer = createSlice({
  name: "authReducer",
  initialState,
  reducers: {
    userauthReducer(state, action) {
      return { ...state, ...action.payload };
    },
  },
});

export const { userauthReducer } = authReducer.actions;
export default authReducer.reducer;
